import axios from 'axios';

// const API_URL = 'http://127.0.0.1:8000/api/';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const API_TOKEN = process.env.REACT_APP_API_TOKEN;
// console.log(API_URL);

if (API_TOKEN) {
  axios.defaults.headers.common['Authorization'] = `Token ${API_TOKEN}`;
}

export const fetchIDs = async () => {
    try {
        const response = await axios.get(API_URL.concat('run_ids/'));
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        return [];
    }
};

export const fetchPoints = async (endpoint) => {
    const allowedEndpoints = ['tsne', 'umap', 'pcoa', 'geo'];

    if (!allowedEndpoints.includes(endpoint)) {
        console.error(`Invalid endpoint: ${endpoint}. Must be one of ${allowedEndpoints.join(', ')}`);
        return [];
    }
    if (endpoint === 'geo') {
        try {
            const response = await axios.get(API_URL.concat(`world_coordinates/`));
            // Expecting equirectangular projection
            return response.data.map(([run_assembly_id, longitude, latitude]) => {
                while (true) {
                    const x = Math.random() * 2 - 1;
                    const y = Math.random() * 2 - 1;
                    if (x ** 2 + y ** 2 < 1) {
                        return [
                            parseFloat(longitude / 180 + x / 500),
                            // parseFloat(point.latitude / 90 / 1.3 + y / 500),
                            // Squish latitude of map :)
                            parseFloat(latitude / 90 / 1.48 + y / 500),
                            // parseFloat(point.latitude / 90 + y / 500),
                        ]
                    }
                }
            });

        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }

    try {
        const response = await axios.get(API_URL.concat(`${endpoint}_norm_data/`));
        return response.data.map(([run_assembly_id, x_norm, y_norm]) => [

            parseFloat(x_norm),
            parseFloat(y_norm),
        ]);
    } catch (error) {
        console.error('Error fetching data:', error);
        return [];
    }
}

export const fetchTaxaCountRank = async (run_assembly_id, rank) => {
    try {
        const response = await axios.get(API_URL.concat(`sample/${run_assembly_id}/${rank}/`));
        return response.data.map(org => [
            org.name,
            parseInt(org.count),
        ]);
    } catch (error) {
        console.error('Error fetching data:', error);
        return [];
    }
}


export const fetchCategoricalValues = async (endpoint) => {
    const allowedEndpoints = ['source_biome', 'instrument_model', 'geographic_location', 'environment_material', 'study_id', 'source_biome_clustered'];

    if (!allowedEndpoints.includes(endpoint)) {
        console.error(`Invalid endpoint: ${endpoint}. Must be one of ${allowedEndpoints.join(', ')}`);
        return [];
    }

    try {
        const response = await axios.get(API_URL.concat(`${endpoint}/`));
        return response.data.map(([run_assembly_id, value]) => value);
    } catch (error) {
        console.error('Error fetching data:', error);
        return [];
    }
};

export const fetchTotalBiomeCounts = async () => {
    try {
        const response = await axios.get(API_URL.concat('source_biome/'));
        const biomeCounts = {};

        response.data.forEach(([run_assembly_id, biome]) => {
            const cleanBiome = biome.replace(/root:/g, '').trim();
            biomeCounts[cleanBiome] = (biomeCounts[cleanBiome] || 0) + 1;
        });

        return biomeCounts;
    } catch (error) {
        console.error('Error fetching total biome counts:', error);
        return {};
    }
};


export const fetchContinuousValues = async (endpoint, userID = null) => {
    // const allowedEndpoints = ['shannon_index_e', 'simpson_index', 'richnes', 'chao1', 'unknownness_score'];
    const allowedEndpoints = ['shannon_index_e', 'simpson_index', 'richnes', 'chao1', 'unknownness_score', 'temperature'];

    if (!allowedEndpoints.includes(endpoint)) {
        console.error(`Invalid endpoint: ${endpoint}. Must be one of ${allowedEndpoints.join(', ')}`);
        return [];
    }

    try {
        const response = await axios.get(`${API_URL}${endpoint}/`);
        return response.data.map(([run_assembly_id, value]) => parseFloat(value));
    } catch (error) {
        console.error('Error fetching data:', error);
        return [];
    }
}


export const fetchSampleInfo = async (endpoint) => {
    // http://127.0.0.1:8000/api/sample/ERR2508811/
    // console.log(API_URL.concat(`sample/${endpoint}/`));
    try {
        const response = await axios.get(API_URL.concat(`sample/${endpoint}/`));
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        return [];
    }
}

export const fetchMultipleSamplesMetaInfo = async (sampleIds, signal) => {
    try {
        const response = await axios.post(`${API_URL}samples/`, {
            run_assembly_ids: sampleIds
        }, {
            signal: signal
        });
        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) {
            throw error;
        }
        console.error('Error fetching multiple samples data:', error);
        return [];
    }
}

export const fetchMultipleSamplesTaxaInfo = async (sampleIds, signal) => {
    try {
        const response = await axios.post(`${API_URL}samples_taxa/`, {
            run_assembly_ids: sampleIds
        }, {
            signal: signal
        });
        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) {
            throw error;
        }
        console.error('Error fetching multiple samples data:', error);
        return [];
    }
}

export const fetchMultipleSamplesTaxaAggregateInfo = async (sampleIds, signal) => {
    try {
        const response = await axios.post(`${API_URL}sample_taxa_aggregate/`, {
            run_assembly_ids: sampleIds
        }, {
            signal: signal
        });
        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) {
            throw error;
        }
        console.error('Error fetching multiple samples data:', error);
        return [];
    }
}



export const fetchMultipleSamplesInfoBig = async (sampleIds, signal) => {
    // this fetch will also retrieve all taxa data from samples. takes long if 
    // if (sampleIds.length > 10) {
    //     return []
    // }
    try {
        const response = await axios.post(`${API_URL}samples_big/`, {
            run_assembly_ids: sampleIds
        }, {
            signal: signal
        });
        // console.log(response)
        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) {
            throw error;
        }
        console.error('Error fetching multiple samples data:', error);
        return [];
    }
}

export const fetchAggregateTaxa = async () => {
    try {
        const response = await axios.get(API_URL.concat(`taxa_aggregate/`));
        return response.data;
    } catch (error) {
        console.error('Error fetching aggregate taxa:', error);
        return [];
    }
};

export const fetchAggregateTaxaRank = async (rank) => {
    try {
        const response = await axios.get(API_URL.concat(`taxa_aggregate/${rank}/`));
        return response.data;
    } catch (error) {
        console.error('Error fetching aggregate taxa by order:', error);
        return [];
    }
};

export const fetchAverageRelativeAbundanceTaxa = async (rank) => {
    try {
        const response = await axios.get(API_URL.concat(`taxa_average_relative_abundance/`));
        return response.data;
    } catch (error) {
        console.error('Error fetching average relative abundance taxa:', error);
        return [];
    }
};

export const fetchAverageRelativeAbundanceTaxaRank = async (rank, signal) => {
    try {
        const response = await axios.get(API_URL.concat(`taxa_average_relative_abundance/${rank}/`), {
            signal: signal
        });

        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) {
            throw error;
        }
        console.error('Error fetching average relative abundance taxa by order:', error);
        return [];
    }
};

export const fetchSumRelativeAbundanceTaxaRank = async (rank, signal) => {
    try {
        const response = await axios.get(API_URL.concat(`taxa_sum_relative_abundance/${rank}/`), {
            signal: signal
        });

        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) {
            throw error;
        }
        console.error('Error fetching average relative abundance taxa by order:', error);
        return [];
    }
};


export const fetchIDsbyTaxonThreshold = async (taxon, threshold = 20) => {
    try {
        const response = await axios.get(`${API_URL}samples_by_taxon/`, {
            params: {
                taxon_name: taxon,
                threshold: threshold
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching samples by taxon and threshold:', error);
        return { run_assembly_ids: [] };
    }
};


export const fetchIDsbySmartQuery = async (query) => {
    try {
        const response = await axios.get(`${API_URL}samples_by_smart_search/`, {
            params: {
                query: query,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching samples query:', error);
        return { run_assembly_ids: [], error: error };
    }
};


export const fetchUserData = async (userID) => {
    try {
        // const response = await axios.get(`${API_URL}user_otu_data/?user_id=user123/`, {
        const response = await axios.get(`${API_URL}user_otu_data/?user_id=${userID}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching samples query:', error);
        return { run_assembly_ids: [] };
    }
};


export const postFile = async (data) => {
    try {
        const response = await axios.post(API_URL.concat(`upload_otu/`), data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        // console.log('File uploaded successfully:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error uploading file:', error);
        throw error;
    }
};


// download directly from mgnify:
// https://www.ebi.ac.uk/metagenomics/api/v1/analyses/MGYA00200529/file/ERR2729849_MERGED_FASTQ_SSU_OTU.tsv
// https://www.ebi.ac.uk/metagenomics/api/v1/analyses/<mgnify_analysis_id>/file/<run_assembly_id>_MERGED_FASTQ_SSU_OTU.tsv
// https://www.ebi.ac.uk/metagenomics/api/v1/analyses/MGYA00409162/file/SRR6417461_MERGED_FASTQ_SSU_OTU.tsv
export const fetchMGnifyOTUData = async (mgnifyAnalysisId, runAssemblyId, signal) => {
    const mgnifyUrl = `https://www.ebi.ac.uk/metagenomics/api/v1/analyses/${mgnifyAnalysisId}/file/${runAssemblyId}_MERGED_FASTQ_SSU_OTU.tsv`;

    try {
        const response = await axios.get(mgnifyUrl, {
            signal: signal,
            headers: {
                'Accept': 'text/plain',
            },
            responseType: 'blob'
        });

        // Create download link
        const blob = new Blob([response.data], { type: 'text/tab-separated-values' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${runAssemblyId}_MERGED_FASTQ_SSU_OTU.tsv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return {
            success: true,
            message: 'File downloaded successfully',
            filename: `${runAssemblyId}_MERGED_FASTQ_SSU_OTU.tsv`
        };
    } catch (error) {
        if (axios.isCancel(error)) {
            throw error;
        }
        console.error('Error downloading MGnify OTU data:', error);
        return {
            success: false,
            error: error.message
        };
    }
};